export enum SettingView {
    AUTOMATED_PLACEMENT = 'Placement',
    CATALOGUE = 'Catalogue',
    COPILOT = 'Copilot'
}
